import { Component, computed, EventEmitter, input, OnInit, Output, Signal } from '@angular/core';
import { BaseComponent } from '@shared-components/base-component';
import { BrandLogoComponent } from '@shared-components/brand-logo/brand-logo.component';
import { ExpertImageComponent } from '@shared-components/expert-image/expert-image.component';
import { AppHelper } from '@shared-helpers/appHelper';
import { ExpertModel } from '@shared-model/expert/ExpertModel';
import { ExpertStatusMode } from '@shared-model/expert/ExpertStatusMode';

@Component({
  selector: 'fourd-component-header',
  imports: [ExpertImageComponent,BrandLogoComponent],
  templateUrl: './component-header.component.html',
  providers: [...BaseComponent.componentProviders],
})
export class ComponentHeaderComponent extends BaseComponent implements OnInit {
  readonly expert = input<ExpertModel>(undefined);
  readonly showExpertPhoneStatus = input<boolean>(false);
  readonly showExpertOnlineChatStatus = input<boolean>(false);

  @Output() close = new EventEmitter<boolean>();

  showExpertStatus: Signal<boolean> = computed(() => this.expertStatusMode() != ExpertStatusMode.None, { equal: AppHelper.objectsEqual });

  expertStatusMode: Signal<ExpertStatusMode> = computed(() => {
    if (this.showExpertOnlineChatStatus()) {
      if (this.showExpertPhoneStatus()) {
        return ExpertStatusMode.Combined;
      }
      else {
        return ExpertStatusMode.OnlineChat;
      }
    }
    else {
      if (this.showExpertPhoneStatus()) {
        return ExpertStatusMode.Phone;
      }
      else {
        return ExpertStatusMode.None;
      }
    }
  }, { equal: AppHelper.objectsEqual });

  isExpertAvailable: Signal<boolean> = computed(() => {
    const expert = this.expert();
    const expertValue = this.expert();
    const expertVal = this.expert();
    switch (this.expertStatusMode()) {
      case ExpertStatusMode.Phone:
        return expert?.IsOnlineForPhone && !expert?.IsBusy;
      case ExpertStatusMode.OnlineChat:
        return expertValue?.IsOnlineForOnlineChat && !expertValue?.IsBusy;
      case ExpertStatusMode.Combined:
        return (expertVal?.IsOnlineForPhone || expertVal?.IsOnlineForOnlineChat) && !expertVal?.IsBusy;
    }
    return false;
  }, { equal: AppHelper.objectsEqual });

  isExpertBusy: Signal<boolean> = computed(() => {
    const expert = this.expert();
    const expertValue = this.expert();
    const expertVal = this.expert();
    switch (this.expertStatusMode()) {
      case ExpertStatusMode.Phone:
        return expert?.IsOnlineForPhone && !!expert?.IsBusy;
      case ExpertStatusMode.OnlineChat:
        return expertValue?.IsOnlineForOnlineChat && !!expertValue?.IsBusy;
      case ExpertStatusMode.Combined:
        return (expertVal?.IsOnlineForPhone || expertVal?.IsOnlineForOnlineChat) && !!expertVal?.IsBusy;
    }
    return false;
  }, { equal: AppHelper.objectsEqual });

  constructor() { super("ComponentHeaderComponent"); }

  ngOnInit() {
  }

  onClose(event: Event): void {
    this.handleClickEvent(event);
    this.close.emit();
  }
}

